export default __webpack_public_path__ + "img/apply_text_1-c3e006a2.png";